module.exports = __webpack_public_path__ + "static/Mainframe-Whitepaper-485f32bbcc4dc9308ec1ee36084757d8.pdf";